module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account--wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card form--account"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('H1', [_vm._v("Pregled konfiguracije")])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "switches"
  }, [_c('toggle-button', {
    attrs: {
      "value": _vm.model.autoRecommendationEnabled
    },
    model: {
      value: (_vm.model.autoRecommendationEnabled),
      callback: function($$v) {
        _vm.$set(_vm.model, "autoRecommendationEnabled", $$v)
      },
      expression: "model.autoRecommendationEnabled"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "switches"
  }, [_c('toggle-button', {
    attrs: {
      "value": _vm.model.isNightShiftEnabled
    },
    model: {
      value: (_vm.model.isNightShiftEnabled),
      callback: function($$v) {
        _vm.$set(_vm.model, "isNightShiftEnabled", $$v)
      },
      expression: "model.isNightShiftEnabled"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Broj porudžbina po kuriru - koji je maksimalan broj porudžbine koje kurir može imati na sebi u jednom trenutku")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.assignedOrdersLimit),
      expression: "model.assignedOrdersLimit"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Broj porudžbina po kuriru",
      "name": "ime"
    },
    domProps: {
      "value": (_vm.model.assignedOrdersLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "assignedOrdersLimit", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Maksimalno minuta koje kurir može čekati ispred lokala dok se porudžbina ne spremi")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.orderPreparationTimeLimitInMinutes),
      expression: "model.orderPreparationTimeLimitInMinutes"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Maksimalno minuta ",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.orderPreparationTimeLimitInMinutes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "orderPreparationTimeLimitInMinutes", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Minimalno vreme pripreme - ovo polje će biti minimalna vrednost pripreme kada lokali budu hteli da kreiraju porudžbinu")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.preparationTime),
      expression: "model.preparationTime"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Maksimalno minuta ",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.preparationTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "preparationTime", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Slanje SMS poruka neregistrovanim kupcima")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "switches"
  }, [_c('toggle-button', {
    attrs: {
      "value": _vm.model.sendSmsToNewCustomersEnabled
    },
    model: {
      value: (_vm.model.sendSmsToNewCustomersEnabled),
      callback: function($$v) {
        _vm.$set(_vm.model, "sendSmsToNewCustomersEnabled", $$v)
      },
      expression: "model.sendSmsToNewCustomersEnabled"
    }
  })], 1)])])])])]), _vm._v(" "), (_vm.isVisiblePrice()) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "#FFF"
    }
  }, [_vm._v("Dodatak na cenu za noćnu smenu")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Dodatak na cenu za noćnu smenu (u RSD) ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.addPriceToNightShift),
      expression: "model.addPriceToNightShift"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Dodatak na cenu za noćnu",
      "name": "dodatakNaCenu"
    },
    domProps: {
      "value": (_vm.model.addPriceToNightShift)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "addPriceToNightShift", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isVisiblePrice()) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "#FFF"
    }
  }, [_vm._v("Cene za zatvaranje dana")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Procentualna zarada za sopstvena vozila (uneti procenat, npr: 40)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.ownVehiclePrice),
      expression: "model.ownVehiclePrice"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Sopstvena vozila",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.ownVehiclePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "ownVehiclePrice", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Cena po dostavi za biciklo")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.bicycleVehiclePrice),
      expression: "model.bicycleVehiclePrice"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Biciklo",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.bicycleVehiclePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "bicycleVehiclePrice", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Procentualna zarada za firmina vozila (uneti procenat, npr: 40) ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.companyVehiclePrice),
      expression: "model.companyVehiclePrice"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Firmina vozila",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.companyVehiclePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "companyVehiclePrice", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.isVisiblePrice()) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "#FFF"
    }
  }, [_vm._v("Cene za kredit")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Cena kredita u RSD")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.greenVoucher),
      expression: "model.greenVoucher"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Cena za zeleni kupon",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.greenVoucher)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "greenVoucher", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.visibleDevelop()) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Cifra za ispod koje se crvene kuponi")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.blueVoucher),
      expression: "model.blueVoucher"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Cena za plavi kupon",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.blueVoucher)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "blueVoucher", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.visibleDevelop()) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Flag da li ce se prikazati kuponi na IOS zbog apple")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.whiteVoucher),
      expression: "model.whiteVoucher"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Cena za beli kupon",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.whiteVoucher)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "whiteVoucher", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.isVisiblePrice()) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "#FFF"
    }
  }, [_vm._v("Cena vožnji ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Cena gradske vožnje (RSD)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discounts.priceForCity),
      expression: "discounts.priceForCity"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Cena gradske vožnje (RSD)",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.discounts.priceForCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.discounts, "priceForCity", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.isVisiblePrice()) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "#FFF"
    }
  }, [_vm._v("Cena po KM ukoliko je nepoznata adresa")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Cena po KM")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.deliveryPricePerKilometer),
      expression: "model.deliveryPricePerKilometer"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Cena po KM",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.deliveryPricePerKilometer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "deliveryPricePerKilometer", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isVisiblePrice()) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "#FFF"
    }
  }, [_vm._v("Cene goriva u RSD")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Cena benzina")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prices.gasoline),
      expression: "prices.gasoline"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Cena benzina",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.prices.gasoline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prices, "gasoline", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Cena dizela")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prices.diesel),
      expression: "prices.diesel"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Cena dizela",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.prices.diesel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prices, "diesel", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Cena gasa")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prices.tng),
      expression: "prices.tng"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Cena gasa",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.prices.tng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prices, "tng", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Cena metana")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prices.methane),
      expression: "prices.methane"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Cena metana",
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.prices.methane)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prices, "methane", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('button', {
    staticClass: "button button-outline",
    on: {
      "click": _vm.update
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" Sačuvaj\n                                    ")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form-label"
  }, [_c('b', [_vm._v("Automatska dodela")]), _vm._v("  - ukoliko je ovo upaljeno, svaka nova porudžbina od lokala će biti automatski dodeljene")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form-label"
  }, [_c('b', [_vm._v("Noćna smena")]), _vm._v(" - ukoliko je ovo ukljuceno cena se povecava za polje -> 'Dodatak na cenu za noćnu smenu'")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('img', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "src": require("../../assets/img/coin.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon",
    staticStyle: {
      "background": "cornflowerblue"
    }
  }, [_c('i', {
    staticClass: "ti-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon",
    staticStyle: {
      "background": "lightgrey"
    }
  }, [_c('i', {
    staticClass: "ti-apple"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('img', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "src": require("../../assets/img/coin.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33b064dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Configuration/Configuration.vue
// module id = 469
// module chunks = 1